export const COST_SUMMARY_REQUEST = 'COST_SUMMARY_REQUEST';
export const COST_SUMMARY_SUCCESS = 'COST_SUMMARY_SUCCESS';
export const COST_SUMMARY_FAIL = 'COST_SUMMARY_FAIL';
export const COST_SUMMARY_RESET = 'COST_SUMMARY_RESET';

// Action types for analytics
export const ANAL_COST_INVENTORY_REQUEST = 'ANAL_COST_INVENTORY_REQUEST';
export const ANAL_COST_INVENTORY_SUCCESS = 'ANAL_COST_INVENTORY_SUCCESS';
export const ANAL_COST_INVENTORY_FAIL = 'ANAL_COST_INVENTORY_FAIL';
export const ANAL_COST_INVENTORY_RESET = 'ANAL_COST_INVENTORY_RESET';